<span [innerHTML]="labelWithShortcut"></span>
